import React, { useState } from "react";
import DynamicForm from "./DynamicForm";
import { useStateContext } from "../../context/AdminDashboard/ModelsAddEditContext";
import Icon from "../atoms/Icon";
import BtnModal from "../atoms/BtnModal";
const InputForm = ({ onInputChange, number, onDeleteForm, quality, data }) => {
  // console.log(number)
  return (
    <DynamicForm
      onchangeInput={onInputChange}
      number={number}
      onDeleteForm={onDeleteForm}
      quality={quality} // Pass the updated callback to DynamicForm
      data={data}
    />
  );
};

const ParentComponent = ({ submit,text }) => {
  const {
    inputForms,
    handleInputChange,
    handleAddForm,
    // handleFormSubmit,
    handleDeleteForm,
    quality,
  } = useStateContext();

  // if(inputForms[0].id.length>0){
  // console.log("*************");
  // console.log(inputForms);
  // }
  return (
    <div className="flex flex-col ">
      {inputForms.map((form, index) => (
        <InputForm
          number={index + 1}
          key={form.id}
          onInputChange={(e) => handleInputChange(index, e)}
          onDeleteForm={() => handleDeleteForm(index)}
          quality={quality}
          data={form}
        />
      ))}
      <div className="w-full border-gray border-5 h-40 border-dashed mt-7.5px flex items-center mb-25">
        <button
          className="w-full h-full text-14 text-gray_L flex flex-col items-center justify-center gap-1"
          onClick={handleAddForm}>
          <Icon iconName={"add"} />
          افزودن سنسور جدید
        </button>
      </div>
      <div className="w-52 mr-auto pb-7.5px">
        <BtnModal accept={submit} text={text?text:"ثبت و افزودن مدل"} />
      </div>
    </div>
  );
};

export default ParentComponent;
